export const CL_EVENT_NAMES = {
  ADDED_TO_CART: 'Added to Cart',
  ADDED_TO_STORE: 'Added to Store',
  INITIATE_CHECKOUT: 'Initiate Checkout',
  PURCHASE: 'Purchase',
} as const;

export const CL_DATA_KEYS = {
  ACTION_NAME: 'Action Name',
  ACTION_TIMESTAMP: 'Action Timestamp',
  EMAIL: 'Email',
  PHONE_NUMBER: 'Phone number',
  FIRST_NAME: 'First name',
  LAST_NAME: 'Last name',
  ORG: 'Org',
  SCHOOL: 'School',
  ROLE: 'Role',
  MEMBERS_IN_ORG: 'Members In Org',
  GRAD_YEAR: 'Grad Year',
  ZIP_POSTAL_CODE: 'ZIP/postal code',
  IP_ADDRESS: 'IP Address',
  GCLID: 'GCLID',
  FBCLID: 'FBCLID',
  TTCLID: 'TTCLID',
  PCLID: 'PCLID',
  EPIK: 'EPIK',
  WBRAID: 'WBRAID',
  GBRAID: 'GBRAID',
  COUNTRY: 'Country',
  CITY: 'City',
  REGION: 'State',
  PAGE_URL: 'Page URL',
  SOURCE: 'Source',
  DESIGN_ID: 'Design ID',
  DESIGN_NAME: 'Design Name',
  PRODUCT_ID: 'Product ID',
  PRODUCT_NAME: 'Product Name',
  STYLE_CODE: 'Style Code',
  CHAPTER_TITLE: 'Chapter Title',
  CHAPTER_ID: 'Chapter ID',
  THEME_TITLE: 'Theme Title',
  THEME_ID: 'Theme ID',
  SCHOOL_TITLE: 'School Title',
  BLOG_ID: 'Blog ID',
  BLOG_TITLE: 'Blog Title',
  BLOG_SLUG: 'Blog Slug',
  SORT_METHOD: 'Sort Method',
  SORT_ORDER: 'Sort Order',
  FILTER_CATEGORY: 'Filter Category',
  FILTER_VALUE: 'Filter Value',
  PARTIAL: 'Partial',
  SECTION: 'Section',
  NAME: 'Name',
  PAGE_TYPE: 'Page Type',
  PRODUCT_TYPE: 'Product Type',
  HEAR_ABOUT_US: 'Hear About Us',
  LOOKBOOK_ID: 'Lookbook ID',
  LOOKBOOK_TITLE: 'Lookbook Title',
} as const;

export const CLICK_ID_TO_CL_DATA_KEY = {
  gclid: CL_DATA_KEYS.GCLID,
  fbclid: CL_DATA_KEYS.FBCLID,
  ttclid: CL_DATA_KEYS.TTCLID,
  pclid: CL_DATA_KEYS.PCLID,
  epik: CL_DATA_KEYS.EPIK,
  wbraid: CL_DATA_KEYS.WBRAID,
  gbraid: CL_DATA_KEYS.GBRAID,
} as const;

export const CLICK_IDS = Object.keys(CLICK_ID_TO_CL_DATA_KEY) as Array<
  keyof typeof CLICK_ID_TO_CL_DATA_KEY
>;
